import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConstantsStore} from './constants.store';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LegalDocumentsService {

  constructor(
    private http: HttpClient,
    private urls: ConstantsStore
  ) { }

  getTermsContent(): Observable<any> {
    return this.http.get<any>(this.urls.legalDocumentsUrl, { params: { type: '1' } });
  }

  downloadActiveLegalDocument(type: number) {
    window.open(`${this.urls.legalDocumentsUrl}/${type}`, '_blank');
  }
}
